import { BreadCrumbItemType } from "../../common/types";
import { getProjectMappings } from "../../services/auth.service";

export const COMMON_ACTIONS = {
  ADD_BREADCRUMB: "ADD_BREADCRUMB",
  REMOVE_BREADCRUMB: "REMOVE_BREADCRUMB",
  SET_HISTORY: "SET_HISTORY",
  RESET_HISTORY: "RESET_HISTORY",
};

export const addBreadCrumbThunk = (breadCrumbs: BreadCrumbItemType[]) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: COMMON_ACTIONS.ADD_BREADCRUMB,
        payload: breadCrumbs,
      });
    } catch (error) {}
  };
};

export const removeBreadCrumbThunk = (breadCrumbs: BreadCrumbItemType[]) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: COMMON_ACTIONS.REMOVE_BREADCRUMB,
        payload: breadCrumbs,
      });
    } catch (error) {}
  };
};

export const setHistoryThunk = (path: string) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: COMMON_ACTIONS.SET_HISTORY,
        payload: path,
      });
    } catch (err) {}
  };
};

export const resetHistoryThunk = () => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: COMMON_ACTIONS.RESET_HISTORY,
      });
    } catch (err) {}
  };
};

export const updateMetaThunk = () => {
  return async (dispatch: any) => {
    try {
      const response = await getProjectMappings();
      if (
        response &&
        response.project_names &&
        response.project_names.length > 0
      ) {
        const projectName = response.project_names[0];
        localStorage.setItem("projectName", projectName);
        if (projectName === "Orion") {
          document.title = "ORION";
        } else if (projectName === "Orbit") {
          document.title = "ORBIT";
        } else if (projectName === "SourcingHub") {
          document.title = "ORION GSA";
        } else {
          document.title = projectName.toUpperCase();
        }
        const link = document.querySelector(
          "link[rel*='icon']"
        ) as HTMLLinkElement | null;
        if (link) {
          link.href = `${
            process.env.PUBLIC_URL
          }/${projectName.toLowerCase()}_logo.svg`;
        } else {
          const newLink = document.createElement("link");
          newLink.type = "image/x-icon";
          newLink.rel = "shortcut icon";
          newLink.href = `${
            process.env.PUBLIC_URL
          }/${projectName.toLowerCase()}_logo.svg`;
          document.getElementsByTagName("head")[0].appendChild(newLink);
        }
      }
    } catch (error) {
      console.error("Error fetching project name:", error);
    }
  };
};
